import { css } from '@emotion/react'
import { graphql } from 'gatsby'
import { ComponentPropsWithoutRef } from 'react'

import { BodyTextBlock } from '@/features/common/'
import { GatsbyImageFocused } from '@/features/common/'
import { LinksList } from '@/features/common/'
import { mq } from '@/theme/mixins'
import { colors } from '@/theme/variables'

interface Props extends ComponentPropsWithoutRef<'section'> {
  data: Queries.AlumnaeDirectoryBodySectionFragment | null
}

export const AlumnaeDirectoryBodySection = ({
  data,
  ...props
}: Props): JSX.Element => {
  const styles = {
    section: css`
      position: relative;
      background: #fff;
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-auto-flow: dense;
      column-gap: var(--gtr-72);
      padding: var(--row-72) var(--margin) var(--row-108);
      justify-content: flex-start;
      ${mq().m} {
        grid-template-columns: 1fr;
      }
    `,
    directorySection: css``,
    heading: css`
      font-size: var(--fs-60);
      margin: 0.5em 0;
    `,
    directoryBody: css``,
    socialSection: css`
      border-top: 1px solid ${colors.gray85};
      padding-top: var(--row-36);
      margin-top: var(--row-54);
    `,
    socialLinks: css``,
    image: css`
      grid-row: 1 / 4;
      grid-column: 2 / 3;
      height: 100%;
      ${mq().m} {
        display: none;
      }
    `,
  }
  return (
    <section
      css={styles.section}
      {...props}
    >
      <section css={styles.directorySection}>
        <h2 css={styles.heading}>{data?.directoryHeading}</h2>
        <BodyTextBlock
          css={styles.directoryBody}
          data={data?.directoryBody}
        />
      </section>
      <section css={styles.socialSection}>
        <h2 css={styles.heading}>{data?.socialHeading}</h2>
        {data?.socialLinks?.map(linksList => (
          <LinksList
            css={styles.socialLinks}
            data={linksList}
            key={linksList?.id}
          />
        ))}
      </section>
      <GatsbyImageFocused
        css={styles.image}
        data={data?.image}
        image={data?.image?.gatsbyImageData}
        aspectRatio={3 / 4}
      />
    </section>
  )
}

export const AlumnaeDirectoryBodySectionFragment = graphql`
  fragment AlumnaeDirectoryBodySection on DatoCmsAlumnaeDirectoryBodySection {
    __typename
    id: originalId
    directoryHeading
    directoryBody {
      ...BodyTextBlock
    }
    socialHeading
    socialLinks {
      ...LinksList
    }
    image {
      ...ImageFocalData
      gatsbyImageData(
        width: 960
        sizes: "50vw"
        imgixParams: { ar: "3:4", fit: "crop", crop: "focalpoint" }
      )
    }
  }
`
